import React from 'react';
import reducer from './reducer';

export const LoaderContext = React.createContext({});

const initial = null;

const LoaderData = ({ children }) => {
    const [state, dispatch] = React.useReducer(reducer, initial);
    return (
        <LoaderContext.Provider value={[state, dispatch]}>
            {children}
        </LoaderContext.Provider>
    );
};

export default LoaderData;
